import React from 'react';
import PropTypes from 'prop-types';
import StageMenu from '../Components/Content/StageMenu';
import ApplicationHeader from '../Components/Content/ApplicationHeader'; 
import ApplicationFooter from '../Components/Content/ApplicationFooter'; 
import Search from '../Components/Widgets/Search';
import StageOptions from './Application/StageOptions';
import MainMenuPanel from './Application/MainMenu';
import LanguageSelector from './Application/LanguageSelector';
import {MainMenuToggle} from './Application/MainMenu';
import {StageOptionsToggle} from './Application/StageOptions';
import ValueDateCalendar from './Application/ValueDateCalendar';
import {actions, selectors} from '../Redux/index';
import {connect} from 'react-redux'; 
import {Link, useNavigate, useLocation, Outlet} from 'react-router-dom';
import {Waypoint} from 'react-waypoint';

import dbLogo from '../Resources/Images/db_logo.svg';
import dbIdentifier from '../Resources/Images/db_identifier.svg';

/**
 * This is the container for the main application. It contains every other container and components.
 */

const StageHeader = (props) => { 
    const navigate = useNavigate();

    const showDetailsPage = (currencyPair) => {
        navigate(`/currency-details?currencyPair=${currencyPair}`);
    }

    const addToSpotAndNavigateToSpotPage = (ccyPair) => {
        props.onSearchResultItemAddToSpotOptions(ccyPair);
        navigate('/spot');
    }

    return (
        <header className="stage__header">
            <StageMenu
                optionsToggle={<StageOptionsToggle />}
                search={<Search ccyPairs={props.currencyPairs}
                                currencies={props.currencies}
                                language={props.language}
                                displayMaxResults={20}
                                onResultClick={showDetailsPage}
                                onResultAdd={addToSpotAndNavigateToSpotPage}/>
                        }
            />
        </header>
    )
};

const Application = (props, context) => {
    const location = useLocation();
    let routeHasStageHeader = true;
    let stickyHeaderMiddle = (
        <div>
            <Link to="/" className="stage-menu__replacement">
                <img className="u-brandIdentifier" src={dbIdentifier} alt="DB Markets"/>
            </Link>
            <StageMenu path={location.pathname} optionsToggle={<StageOptionsToggle />} />
        </div>
    );

    if (location.pathname.indexOf('/page') >= 0) {
        routeHasStageHeader = false;
        stickyHeaderMiddle =
            <Link to="/"><img className="u-brandIdentifier" src={dbIdentifier} alt="DB Markets"/></Link>
    }

    return (
        <main aria-label="DB Markets Main Application">
            {/* STICKY HEADER */}
            <ApplicationHeader
                isSticky={true}
                isStickyVisible={props.stickyHeaderVisibility}
                left={<MainMenuToggle />}
                middle={stickyHeaderMiddle} 
                right={
                    <a href="https://www.deutsche-bank.de">
                        <img className="u-brandLogo" src={dbLogo} alt="Deutsche Bank Logo"/>
                    </a>
                }
            />

            {/* APPLICATION HEADER */}
            <ApplicationHeader
                left={
                    <MainMenuToggle />
                }
                middle={
                    <Link to="/">
                        <img className="u-brandIdentifier" src={dbIdentifier} alt="DB Markets"/>
                    </Link>
                }
                right={
                    <a href="https://www.deutsche-bank.de" target="_blank" rel="noopener noreferrer">
                        <img className="u-brandLogo" src={dbLogo} alt="Deutsche Bank Logo"/>
                    </a>
                }
            />

            <section className="stage">
                <div className="u-content">
                    <Waypoint
                        topOffset={30}
                        onEnter={props.onApplicationHeaderEnter}
                        onLeave={props.onApplicationHeaderLeave}
                    />

                    {routeHasStageHeader ? <StageHeader {...props} location={location} /> : null}

                    <Outlet />
                </div>
            </section>

            <MainMenuPanel />
            <StageOptions />
            <ValueDateCalendar />

            <ApplicationFooter languageSelector={<LanguageSelector />} language={props.language}/>
        </main>
    );
};
 
Application.propTypes = {
    children: PropTypes.node
};

const mapDispatchToProps = (dispatch) => {
    return {
        onApplicationHeaderLeave: () => {
            dispatch(actions.UI.StickyHeader.show());
        },

        onApplicationHeaderEnter: () => {
            dispatch(actions.UI.StickyHeader.hide());
        },
        onSearchResultItemAddToSpotOptions: (ccyPair) => {
            dispatch(actions.UI.SpotOptions.addCcyPair(ccyPair));
            dispatch(actions.Data.Reload.sagaReloadData());
        },
        onToggleOptions: () => {
            dispatch(actions.UI.OptionsMenu.toggleOptionsMenu());
        }
    }
};

const mapStateToProps = (state) => {
    return {
        currentBreakpoint: selectors.UI.Breakpoint.currentBreakpoint(state),
        stickyHeaderVisibility: selectors.UI.StickyHeader.isVisible(state),
        language: selectors.UI.Locale.getLocale(state),
        currencyPairs: selectors.Data.Currency.getCurrencyPairs(state),
        currencies: selectors.Data.Currency.getCurrencies(state),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Application); 